import React, { useState, useEffect } from 'react';
import logo from '../../../assets/appLogo.png';
import showIcon from '../../../assets/hideIcon.png';
import closeIcon from '../../../assets/showIcon.png';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import schema from './ValidationSchema';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiUrl, AppCheckUrl, Register } from '../../services/operations/authAPI';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Loader/Loader';

const RegistrationPage = () => {
  const { register, handleSubmit, watch, setValue, formState: { errors ,isValid} } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange"
  });

  const [email, setEmail] = useState('');
  const [showPasswordToggle, setShowPasswordToggle] = useState(false);
  // const [appUrlMessage, setAppUrlMessage] = useState('');
  // const [isAppUrlAvailable, setIsAppUrlAvailable] = useState(false);
  // const [api, setApi] = useState('');
  const [isChecking, setIsChecking] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);

  useEffect(() => {
  const params = new URLSearchParams(location.search);
  
  const base64Param = params.get('data');
  const emailFromParams = base64Param ? atob(base64Param) : '';
  
    if (!emailFromParams) {
      navigate('/');
    } else {
      setEmail(emailFromParams); 
    }
  }, [location, navigate]);
  

  const name = watch('name');
   const websiteUrl = watch('websiteUrl');
  const password = watch('password');
  const companyName = watch('companyName');
  const terms = watch('terms');

  // const isFormValid = name && password && websiteUrl && companyName && terms && Object.keys(errors).length === 0;
  // useEffect(() => {
  //   const fetchApiUrl = async () => {
  //     try {
  //       const response = await dispatch(apiUrl());
  //       setApi(response?.data?.url || '');
  //     } catch (error) {
  //       console.error('Error fetching API URL:', error);
  //     }
  //   };

  //   fetchApiUrl();
  // }, [dispatch]);

  // const handleAppUrlChange = async (e) => {
  //   const enteredUrl = e.target.value;
  //   setIsChecking(true);
  //   setValue('appUrl', enteredUrl); 
  //   if (enteredUrl.trim().length > 2) {
  //     try {
  //       const response = await dispatch(AppCheckUrl({ app_url : enteredUrl }));
  //       if (response?.data?.status === 200) {
  //         setAppUrlMessage(response.data.message);
  //         setIsAppUrlAvailable(response.data.available);
  //       } else {
  //         setAppUrlMessage('Invalid App URL');
  //         setIsAppUrlAvailable(false);
  //       }
  //     } catch (error) {
  //       setAppUrlMessage('Error checking App URL');
  //       setIsAppUrlAvailable(false);
  //     }
  //   } else {
  //     setAppUrlMessage('');
  //     setIsAppUrlAvailable(false);
  //   }
  //   setIsChecking(false);
  // };

  const togglePasswordVisibility = () => {
    setShowPasswordToggle(prevState => !prevState);
  };

  const onSubmit = async (data) => {
    
   const encodedPassword = btoa(data.password);
    const payload = {
      name: data.name,
      email: email,
      password: encodedPassword,
      website_url:websiteUrl,
      company_name: companyName,
    };
    await dispatch(Register(payload, navigate));
  };

  return (
    <div className='registration-started'>
      {loading && <Loader />}
      <img src={logo} className='app-image' alt='app-logo' onClick={() => navigate('/')} />
      <div className='registration-form'>
        <h2 className='reg-heading'>Get Started</h2>
        <p className='reg-desc'>
          <span style={{ color: 'rgba(26, 76, 255, 1)', fontWeight: '700' }}>{email}</span>
          <span>Your email is verified, complete sign-up to explore features</span>
        </p>
        <form onSubmit={handleSubmit(onSubmit)} className='reg-form'>
          <div className='register-form-group'>
            <fieldset className={`register-form-border ${errors.name ? 'input-error' : ''}`}>
              <legend>Your Name</legend>
              <input type='text' id='name' placeholder='Enter Name' className='register-form-input' {...register('name')} />
            </fieldset>
            {errors.name && <p className='error-message'>{errors.name.message}</p>}
          </div>

          <div className='register-form-group'>
            <fieldset className={`register-form-border ${errors.companyName ? 'input-error' : ''}`}>
              <legend>Company Name</legend>
              <input type='text' id='companyName' placeholder='Enter Company Name' className='register-form-input' {...register('companyName')} />
            </fieldset>
            {errors.companyName && <p className='error-message'>{errors.companyName.message}</p>}
          </div>

          <div className='register-form-group'>
            <fieldset className="register-form-border">
              <legend>Website URL</legend>
              <div className='app-url-wrapper'>
                <input type='text' id='websiteUrl' defaultValue="https://" placeholder='Enter Website url' className='register-form-input-url' {...register('websiteUrl')}  />
                {/* <span className='static-domain'>.{api}</span> */}
              </div>
            </fieldset>
             {errors.websiteUrl && <p className='error-message'>{errors.websiteUrl.message}</p>}
            {/* {isChecking ? (
      <p className="validation-message checking" style={{color:" rgba(0, 0, 0, 0.5)"}}>Checking...</p>
    ) : (
      appUrlMessage && (
        <p className={`validation-message ${isAppUrlAvailable ? "success" : "error"}`}>
          {appUrlMessage}
        </p>
      )
    )} */}
            {/* {appUrlMessage && <p className={`validation-message ${isAppUrlAvailable ? 'success' : 'error'}`}>{appUrlMessage}</p>} */}
          </div>

          <div className='register-form-group'>
            <fieldset className={`register-form-border ${errors.password ? 'input-error' : ''}`}>
              <legend>Enter Password</legend>
              <input type={showPasswordToggle ? 'text' : 'password'} id='password' placeholder='Enter password' className='register-form-input' {...register('password')} />
              <span className="password-toggle-icon" onClick={togglePasswordVisibility} style={{ top: "20px", right: "20px" }}>
                <img src={showPasswordToggle ? showIcon : closeIcon} alt='toggle visibility' />
              </span>
            </fieldset>
            {errors.password && <p className='error-message'>{errors.password.message}</p>}
          </div>

          <div className='checkbox-group'>
            <input type='checkbox' id='terms' {...register('terms')} />
            <label htmlFor='terms'>I agree to&nbsp;<a href='#'>terms of services</a>&nbsp;and&nbsp;<a href='#'>privacy policies</a></label>
          </div>
          {errors.terms && <p className='error-message' style={{margin:"5px 0px 10px 0px"}}>{errors.terms.message}</p>}

          <button
            type='submit'
            className='button-theme registration-button'
            style={{
              backgroundColor: isValid  ? 'rgba(143, 222, 204, 1)' : '',
              cursor: isValid  ? 'pointer' : 'not-allowed',
              width: '500px',
            }}
            // disabled={!isValid }
          >
            Next
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegistrationPage;
